import { Routes, RouterModule } from '@angular/router';
import { NewTaskComponent } from './tasks/new-task/new-task.component';
import { ListTasksComponent } from './tasks/list-tasks/list-tasks.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { AppGuard } from './auth/app-guard';
import { AllTasksComponent } from './tasks/all-tasks/all-tasks.component';
import { AppGuardAdmin } from './auth/app-guard-admin';



const appRoutes: Routes = [
    {path: '', component: ListTasksComponent, canActivate: [AppGuard]},
    {path: 'new-task', component: NewTaskComponent, canActivate: [AppGuard]},
    {path: 'list-tasks', component: ListTasksComponent, canActivate: [AppGuard]},
    {path: 'all-tasks', component: AllTasksComponent, canActivate: [AppGuardAdmin]},
    {path: 'login', component: LoginComponent},
    {path: 'register', component: RegisterComponent},
    // Otherwise redirect to home
    {path: '**', redirectTo: ''}
];


export const routing  = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app-routing.ts